import React from 'react';
// import Analysis from '../../components/Analysis/analysis';
// import  TestSeriesSavedQuestions from '../../components/TestSeriesSavedQuestions/testSeriesSavedQuestions'
import ReleasePlan from "../ReleasePlan/ReleasePlan";
import TestListTab from "./TestListTab";

/**
 * TestSeriesQuiz toggle component.
 * @param props
 * @returns {*}
 * @constructor
 */
function TestSeriesQuiz(props) {
    const { quizGroups, lang, selectedIndex, singleTestSeriesLoading } = props;
    return (
        <div className="analysis-component">
            {selectedIndex === 0 &&
            <TestListTab quizGroups={quizGroups} lang={lang} singleTestSeriesLoading={singleTestSeriesLoading}/>}
            {/* {selectedIndex === 1 && <Analysis history={history}/>} */}
            {selectedIndex === 1 && <ReleasePlan groups={quizGroups} lang={lang}/>}
            {/* {selectedIndex === 3 &&
            <TestSeriesSavedQuestions history={history} selectedIndex={selectedIndex}
                                      testSeriesId={testSeriesId}/>
            } */}

        </div>
    );
}

export default TestSeriesQuiz;
